// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreOpticomm = (client) => ({
    /**
     * `POST /store/opticomm/company-invites/accept`
     *
     * @operationId StoreOpticommCompanyInvitesAcceptPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/company-invites/accept/route.ts
     */
    acceptEmployeeInvite: (body, query, headers) => client.fetch("/store/opticomm/company-invites/accept", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/carts/:id/handoff/comments`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartsIdHandoffCommentsPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/carts/[id]/handoff/comments/route.ts
     */
    createCartsHandoffComment: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/carts/:id/handoff/comments", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/customers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCreateCustomer
     * @source apps/backend/src/api/store/opticomm/customers/route.ts
     */
    createCustomer: (body, query, headers) => client.fetch("/store/opticomm/customers", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/customers/me/addresses`
     *
     * @operationId StoreOpticommCreateCustomerAddressWithGst
     * @source apps/backend/src/api/store/opticomm/customers/me/addresses/route.ts
     */
    createCustomerAddressWithGst: (body, query, headers) => client.fetch("/store/opticomm/customers/me/addresses", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/device-tokens`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommDeviceTokenRegister
     * @source apps/backend/src/api/store/opticomm/device-tokens/route.ts
     */
    createDeviceToken: (body, query, headers) => client.fetch("/store/opticomm/device-tokens", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/companies/:id/invites`
     *
     * @operationId StoreOpticommCompaniesIdInvitesPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/companies/[id]/invites/route.ts
     */
    createEmployeeInvite: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/companies/:id/invites", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/try-on/jobs`
     *
     * @operationId StoreOpticommTryOnJobsCreate
     * @source apps/backend/src/api/store/opticomm/try-on/jobs/route.ts
     */
    createTryOnJob: (body, query, headers) => client.fetch("/store/opticomm/try-on/jobs", { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/opticomm/loyalty-points/privacy`
     *
     * @operationId StoreOpticommLoyaltyPointsPrivacyDelete
     * @source apps/backend/src/api/store/opticomm/loyalty-points/privacy/route.ts
     */
    deleteLoyaltyPointsPrivacy: (body, query, headers) => client.fetch("/store/opticomm/loyalty-points/privacy", { method: "DELETE", body, query, headers }),
    /**
     * `POST /store/opticomm/try-on/jobs/:id/discard`
     *
     * @operationId StoreOpticommTryOnJobsIdDiscard
     * @source apps/backend/src/api/store/opticomm/try-on/jobs/[id]/discard/route.ts
     */
    discardTryOnJob: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/try-on/jobs/:id/discard", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /store/opticomm/try-on/settings`
     *
     * @operationId StoreOpticommTryOnSettingsGet
     * @source apps/backend/src/api/store/opticomm/try-on/settings/route.ts
     */
    getTryOnSettings: (query, headers) => client.fetch("/store/opticomm/try-on/settings", { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/cart-handoffs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartHandoffsGet
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/cart-handoffs/route.ts
     */
    listCartHandoffs: (query, headers) => client.fetch("/store/opticomm/cart-handoffs", { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/collections`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetCollections
     * @source packages/modules/b2c-core/src/api/store/opticomm/collections/route.ts
     */
    listCollections: (query, headers) => client.fetch("/store/opticomm/collections", { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/companies/:id/invites`
     *
     * @operationId StoreOpticommCompaniesIdInvitesGet
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/companies/[id]/invites/route.ts
     */
    listEmployeeInvites: (id, query, headers) => client.fetch(buildPath("/store/opticomm/companies/:id/invites", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/loyalty-points`
     *
     * @operationId StoreOpticommLoyaltyPointsRetrieve
     * @source apps/backend/src/api/store/opticomm/loyalty-points/route.ts
     */
    listLoyaltyPoints: (query, headers) => client.fetch("/store/opticomm/loyalty-points", { method: "GET", query, headers }),
    /**
     * `POST /store/opticomm/company-invites/lookup`
     *
     * @operationId StoreOpticommCompanyInvitesLookupPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/company-invites/lookup/route.ts
     */
    lookupEmployeeInvite: (body, query, headers) => client.fetch("/store/opticomm/company-invites/lookup", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/carts/:id/handoff/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartsIdHandoffRejectPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/carts/[id]/handoff/reject/route.ts
     */
    rejectCartsHandoff: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/carts/:id/handoff/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/try-on/render-otp/request`
     *
     * @operationId StoreOpticommTryOnRenderOtpRequest
     * @source apps/backend/src/api/store/opticomm/try-on/render-otp/request/route.ts
     */
    requestTryOnRenderOtp: (body, query, headers) => client.fetch("/store/opticomm/try-on/render-otp/request", { method: "POST", body, query, headers }),
    /**
     * `GET /store/opticomm/carts/active`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartsActiveGet
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/carts/active/route.ts
     */
    retrieveCartsActive: (query, headers) => client.fetch("/store/opticomm/carts/active", { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/carts/:id/handoff/history`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartsIdHandoffHistoryGet
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/carts/[id]/handoff/history/route.ts
     */
    retrieveCartsHandoffHistory: (id, query, headers) => client.fetch(buildPath("/store/opticomm/carts/:id/handoff/history", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/collections/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetCollection
     * @source packages/modules/b2c-core/src/api/store/opticomm/collections/[id]/route.ts
     */
    retrieveCollection: (id, query, headers) => client.fetch(buildPath("/store/opticomm/collections/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/orders/:id/handoff/history`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommOrdersIdHandoffHistoryGet
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/orders/[id]/handoff/history/route.ts
     */
    retrieveOrdersHandoffHistory: (id, query, headers) => client.fetch(buildPath("/store/opticomm/orders/:id/handoff/history", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/payment-config`
     *
     * @operationId StoreOpticommPaymentConfigRetrieve
     * @source apps/backend/src/api/store/opticomm/payment-config/route.ts
     */
    retrievePaymentConfig: (query, headers) => client.fetch("/store/opticomm/payment-config", { method: "GET", query, headers }),
    /**
     * `GET /store/opticomm/try-on/jobs/:id`
     *
     * @operationId StoreOpticommTryOnJobsIdRetrieve
     * @source apps/backend/src/api/store/opticomm/try-on/jobs/[id]/route.ts
     */
    retrieveTryOnJob: (id, query, headers) => client.fetch(buildPath("/store/opticomm/try-on/jobs/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /store/opticomm/device-tokens/revoke`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommDeviceTokenRevoke
     * @source apps/backend/src/api/store/opticomm/device-tokens/revoke/route.ts
     */
    revokeDeviceTokens: (body, query, headers) => client.fetch("/store/opticomm/device-tokens/revoke", { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/opticomm/companies/:id/invites/:invite_id`
     *
     * @operationId StoreOpticommCompaniesIdInvitesInviteidDelete
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/companies/[id]/invites/[invite_id]/route.ts
     */
    revokeEmployeeInvite: (id, inviteId, body, query, headers) => client.fetch(buildPath("/store/opticomm/companies/:id/invites/:invite_id", [id, inviteId]), { method: "DELETE", body, query, headers }),
    /**
     * `POST /store/opticomm/auth/customer/reset-password`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommResetCustomerPassword
     * @source apps/backend/src/api/store/opticomm/auth/customer/reset-password/route.ts
     */
    updateAuthCustomerResetPassword: (body, query, headers) => client.fetch("/store/opticomm/auth/customer/reset-password", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/carts/:id/handoff`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOpticommCartsIdHandoffPost
     * @source packages/medusa-plugin-quote-management/src/api/store/opticomm/carts/[id]/handoff/route.ts
     */
    updateCartsHandoff: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/carts/:id/handoff", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/loyalty-points/privacy`
     *
     * @operationId StoreOpticommLoyaltyPointsPrivacyCreate
     * @source apps/backend/src/api/store/opticomm/loyalty-points/privacy/route.ts
     */
    updateLoyaltyPointsPrivacy: (body, query, headers) => client.fetch("/store/opticomm/loyalty-points/privacy", { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/orders/:id/cancel-request`
     *
     * @operationId StoreOpticommOrderCancelRequest
     * @source apps/backend/src/api/store/opticomm/orders/[id]/cancel-request/route.ts
     */
    updateOrdersCancelRequest: (id, body, query, headers) => client.fetch(buildPath("/store/opticomm/orders/:id/cancel-request", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/opticomm/try-on/render-otp/verify`
     *
     * @operationId StoreOpticommTryOnRenderOtpVerify
     * @source apps/backend/src/api/store/opticomm/try-on/render-otp/verify/route.ts
     */
    verifyTryOnRenderOtp: (body, query, headers) => client.fetch("/store/opticomm/try-on/render-otp/verify", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=opticomm.js.map